import { useAuth } from "../hooks/useAuth";
import { getCustomAuthTokens } from "../features/auth/LoginBox";

const SsoTest = () => {
  const auth = useAuth();
  const customTokens = getCustomAuthTokens();

  const user = auth.user;
  const profile = user?.profile;

  return (
    <div style={{ padding: "2rem", fontFamily: "monospace", maxWidth: 800, margin: "0 auto" }}>
      <h1 style={{ marginBottom: "1rem" }}>SSO Test Page</h1>

      <section style={{ marginBottom: "2rem" }}>
        <h2>Auth Status</h2>
        <p>OIDC Authenticated: <strong>{String(auth.isAuthenticated)}</strong></p>
        <p>Custom Auth: <strong>{String(!!customTokens)}</strong></p>
        <p>Loading: <strong>{String(auth.isLoading)}</strong></p>
        {auth.error && <p style={{ color: "red" }}>Error: {auth.error.message}</p>}
      </section>

      {profile && (
        <section style={{ marginBottom: "2rem" }}>
          <h2>User Profile (ID Token Claims)</h2>
          <pre style={{ background: "#f5f5f5", padding: "1rem", borderRadius: 8, overflow: "auto", fontSize: 13 }}>
            {JSON.stringify(profile, null, 2)}
          </pre>
        </section>
      )}

      {user?.access_token && (
        <section style={{ marginBottom: "2rem" }}>
          <h2>Access Token (first 80 chars)</h2>
          <code style={{ wordBreak: "break-all" }}>{user.access_token.slice(0, 80)}...</code>
        </section>
      )}

      <button
        onClick={() => auth.removeUser()}
        style={{ padding: "0.5rem 1rem", cursor: "pointer", marginRight: "1rem" }}
      >
        Sign Out
      </button>
    </div>
  );
};

export default SsoTest;
